import { Entity, usePost, UsePostParams } from '../../../../api';
import { useCallback } from 'react';
import { USER_MANAGEMENT_BASE_URL } from '../consts';
import { TokenType } from '../../components/SendEnrollmentRequest/types';

export type RecipientType = 'unpaired' | 'groupOU';

export type RecipientDetails = Pick<Entity, 'guid' | 'type'>;

interface RecipientBase {
    recipientType: RecipientType;
    recipients?: RecipientDetails[];
}

type RecipientUnpaired = RecipientBase & {
    recipientsDetails: 'unpaired';
};

type RecipientGroupOU = RecipientBase & {
    recipientType: 'groupOU';
    recipientsDetails: RecipientDetails[];
};

type Recipient = RecipientUnpaired | RecipientGroupOU;

export interface SendEnrollmentEmailDetails {
    subject: string;
    content: string;
    recipients: Recipient;
    tokenType: TokenType;
    tokenTypeId: number;
    isCustomEmail: boolean;
    companyLogoUrl: string;
}

export type UseSendEnrollmentEmailParams = UsePostParams<SendEnrollmentEmailDetails, {}>;

const useSendEnrollmentEmail = (params: UseSendEnrollmentEmailParams) => {
    const { post, ...rest } = usePost<SendEnrollmentEmailDetails, {}>(params);

    const sendEnrollmentEmail = useCallback(
        (params: SendEnrollmentEmailDetails) => post(`${USER_MANAGEMENT_BASE_URL}/enrollmentEmails/send`, params),
        [post]
    );

    return {
        ...rest,
        sendEnrollmentEmail
    };
};

export default useSendEnrollmentEmail;
